import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MapPin, ArrowRight } from "lucide-react";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function Locations() {
  const { data } = useQuery({ queryKey: ["locations"], queryFn: async () => (await api.get("/locations")).data });
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Seo title="Faridabad Sector Explorer | Faridabad Property Vault" description="Explore verified properties across Faridabad sectors — NIT, Greater Faridabad, Neharpar and more." />
      <div className="mb-8">
        <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-slate-900">Faridabad Sector Explorer</h1>
        <p className="text-slate-500 mt-2 max-w-2xl">Browse our personally verified inventory sector by sector across Faridabad, Haryana.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {(data?.items || []).map((s) => (
          <Link key={s.id} to={`/locations/${s.slug}`} data-testid={`location-card-${s.slug}`}
            className="group rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-xl transition-all">
            <div className="aspect-[16/9] overflow-hidden bg-slate-100">
              <img src={s.image} alt={s.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading font-bold text-lg text-slate-900 flex items-center gap-1.5"><MapPin className="w-4 h-4 text-indigo-700" /> {s.name}</h3>
                <span className="text-xs bg-indigo-50 text-indigo-800 px-2 py-1 rounded-full font-semibold">{s.property_count}</span>
              </div>
              <p className="text-sm text-slate-500 mt-2 line-clamp-2">{s.description}</p>
              <div className="mt-3 text-sm font-semibold text-indigo-800 flex items-center gap-1 group-hover:gap-2 transition-all">Explore <ArrowRight className="w-4 h-4" /></div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
